
<template>
    <div class="modal-wpr">
        <div class="modal-container" ref="modalContainer">
            <div class="modal">
                <div class="modal-header">

                    <button aria-label="Close" class="closeBtn" data-dismiss="modal" type="button" @click="closeXRay">
                        <img src="/images/icon-close-white.svg" alt="" />
                    </button>
                    <div class="tabs">
                        <button class="tab" :class="{ active: activeTab === 'product' }" @click="activeTab = 'product'">
                            Product JSON
                        </button>
                        <button class="tab" :class="{ active: activeTab === 'block' }" @click="activeTab = 'block'">
                            Block JSON
                        </button>
                        <button class="tab" :class="{ active: activeTab === 'page' }" @click="activeTab = 'page'">
                            Page JSON
                        </button>
                        <button class="tab" :class="{ active: activeTab === 'flyer' }" @click="activeTab = 'flyer'">
                            Flyer JSON
                        </button>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="json-controls">
                        <label class="toggle-switch" title="Toggle visibility of null fields">
                            <input type="checkbox" v-model="hideNullsByTab[activeTab]"/>
                            <span class="slider"></span>
                            <span class="label-text">
                                {{ hideNullsByTab[activeTab] ? 'Show null values' : 'Hide null values'}}
                            </span>
                        </label>
                        <label class="toggle-switch" title="Toggle raw or rendered data">
                            <input type="checkbox" v-model="showRenderedByTab[activeTab]"/>
                            <span class="slider"></span>
                            <span class="label-text">
                                {{ showRenderedByTab[activeTab] ? 'Show raw JSON' : 'Show rendered JSON'}}
                            </span>
                        </label>
                        <label v-if="activeTab === 'product'" class="toggle-switch" title="Hide all empty values">
                            <input type="checkbox" v-model="noEmptyValuesByTab[activeTab]"/>
                            <span class="slider"></span>
                            <span class="label-text">
                                No empty values
                            </span>
                        </label>
                    </div>
                    <pre class="json-output" v-html="formattedJson">
                </pre>
                </div>
                <div class="modal-footer">
                    <button class="download-btn" @click="downloadJSON">Download JSON</button>
                </div>
                <div class="resize-handle" ref="resizer"></div>

            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ClickOutside from 'vue-click-outside'
import featureMixin from "@/mixins/featureMixin";
export default {
    directives: {
        ClickOutside
    },
    mixins: [featureMixin],
    data() {
        return {
            activeTab: 'product',
            hideNullsByTab: {
                product: false,
                block: false,
                page: false,
                flyer: false,
            },
            showRenderedByTab: {
                product: false,
                block: false,
                page: false,
                flyer: false,
            },
            noEmptyValuesByTab: {
                product: false,
            }
        }
    },
    mounted() {
        this.triggerResize();
    },
    computed: {
        ...mapState(['xRayData']),
        ...mapGetters('landingPage', ['currentFlyer']),
        showRendered() {
            return this.showRenderedByTab[this.activeTab]
        },
        formattedJson() {
           if (!this.xRayData) return;
           const tab = this.activeTab;
            let dataToShow;
            
            if (tab === 'product') {
                const blockData = this.xRayData.block?.raw || {};
                const { ...productData } = blockData;
                if (productData.products && Array.isArray(productData.products)) {
                    productData.products = productData.products.map(product => {
                        // eslint-disable-next-line no-unused-vars
                        const { clickRegions, ...productWithoutClickRegions } = product;
                        return productWithoutClickRegions;
                    });
                }
                dataToShow = productData;
            } else if (this.showRendered) {
                const rendered = this.xRayData[tab]?.rendered || {};
                if(tab === 'block'){
                    dataToShow = {
                        block: rendered.block || {},
                        product: rendered.product || {},
                        image: rendered.image || {},
                    }
                } else
                 dataToShow = this.xRayData[tab]?.rendered || {};
            } else {
                 dataToShow = this.xRayData[tab]?.raw || {};
            }
         
            const maxLength = 70000;
            let processedData;
            
            if (tab === 'product' && this.noEmptyValuesByTab[tab]) {
                processedData = this.sortKeysDeep(this.removeEmptyValuesDeep(dataToShow));
            } else if (this.hideNullsByTab[this.activeTab]) {
                processedData = this.prepareJsonForDisplay(dataToShow);
            } else {
                processedData = this.sortKeysDeep(dataToShow);
            }
        
            const jsonStr = JSON.stringify(processedData);
            //return this.prettyPrint(dataToShow)
            return (jsonStr.length > maxLength) 
              ?   JSON.stringify(processedData, null, 3)
              : this.prettyPrintJson(processedData)
            

        },
    },
    methods: {
        ...mapActions(['setXRayMode']),
      
        filterNulls(key, value) {
            return value === null || value === 'null' ? undefined : value
        },
        removeNullsDeep(obj) {
            if (Array.isArray(obj)){
                return obj.map(this.removeNullsDeep)
            } else if (obj && typeof obj === 'object') {
                return Object.fromEntries(
                    Object.entries(obj)
                    .filter(([, value]) => value !== null)
                    .map(([key, value]) => [key, this.removeNullsDeep(value)])
                );
            }
            return obj;
        },
        sortKeysDeep(obj) {
            if (Array.isArray(obj)) {
                return obj.map(this.sortKeysDeep) 
            } else if (obj && typeof obj === 'object') {
                return Object.keys(obj).sort().reduce((acc, key) => {
                    acc[key] = this.sortKeysDeep(obj[key]);
                    return acc;
                }, {});
            }
            return obj;
        },
        prepareJsonForDisplay(data) {
           const cleaned = this.removeNullsDeep(data);
           return this.sortKeysDeep(cleaned);
        },
        removeEmptyValuesDeep(obj) {
            if (Array.isArray(obj)) {
                return obj.map(this.removeEmptyValuesDeep).filter(item => {
                    return item !== null && 
                           item !== undefined && 
                           item !== false && 
                           item !== '' &&
                           !(Array.isArray(item) && item.length === 0) &&
                           !(typeof item === 'object' && Object.keys(item).length === 0);
                });
            } else if (obj && typeof obj === 'object') {
                const cleaned = {};
                for (const [key, value] of Object.entries(obj)) {
                    const cleanedValue = this.removeEmptyValuesDeep(value);
                    if (cleanedValue !== null && 
                        cleanedValue !== undefined && 
                        cleanedValue !== false && 
                        cleanedValue !== '' &&
                        !(Array.isArray(cleanedValue) && cleanedValue.length === 0) &&
                        !(typeof cleanedValue === 'object' && Object.keys(cleanedValue).length === 0)) {
                        cleaned[key] = cleanedValue;
                    }
                }
                return cleaned;
            }
            return obj;
        },
        triggerResize() {
            const box = this.$refs.modalContainer;
            const resizer = this.$refs.resizer;

            let startX, startY, startWidth, startHeight;

            const initResize = (e) => {
                e.preventDefault();
                const evt = e.touches ? e.touches[0] : e;

                startX = evt.clientX;
                startY = evt.clientY;
                startWidth = box.offsetWidth;
                startHeight = box.offsetHeight;
                box.classList.add('resizing');

                if (e.touches) {
                    window.addEventListener('touchmove', doResize);
                    window.addEventListener('touchend', stopResize);
                } else {
                    window.addEventListener('mousemove', doResize);
                    window.addEventListener('mouseup', stopResize);
                }
            };

            const doResize = (e) => {
                const evt = e.touches ? e.touches[0] : e;
                const newWidth = startWidth + (evt.clientX - startX) ;
                const newHeight = startHeight + (evt.clientY - startY) ;

                const maxWidth = window.innerWidth;
                const maxHeight = window.innerHeight - 100

                box.style.width = Math.min(newWidth, maxWidth) + 'px';
                box.style.height = Math.min(newHeight, maxHeight) + 'px';
            }

            const stopResize = (e) => {
                box.classList.remove('resizing');
                if (e.touches) {
                      window.removeEventListener('touchmove', doResize);
                    window.removeEventListener('touchend', stopResize);
                }else {
                     window.removeEventListener('mousemove', doResize);
                    window.removeEventListener('mouseup', stopResize);
                }
            };
            resizer.addEventListener('mousedown', initResize);
            resizer.addEventListener('touchstart', initResize, {passive: false})
        },

        closeXRay() {
            this.setXRayMode(null);
        },
        downloadJSON() {
            let dataToDownload, fileName;
            if (this.activeTab === 'product') {
                const blockData = this.xRayData.block?.raw || {};
                const { ...productData } = blockData;
                if (productData.products && Array.isArray(productData.products)) {
                    productData.products = productData.products.map(product => {
                        // eslint-disable-next-line no-unused-vars
                        const { clickRegions, ...productWithoutClickRegions } = product;
                        return productWithoutClickRegions;
                    });
                }
                dataToDownload = productData;
                let zoneLabel = this.xRayData.block?.raw.zones?.[0] ?? '';
                if (zoneLabel) {
                    fileName = `products_${this.currentFlyer?.title}_P${this.xRayData?.page.raw.index + 1}_B${this.xRayData.block.raw.index}_${zoneLabel}.json`
                } else {
                    fileName = `products_${this.currentFlyer?.title}_P${this.xRayData?.page.raw.index + 1}_basebars.json`
                }
            } else if (this.activeTab === 'block') {
                let zoneLabel = this.xRayData.block?.raw.zones?.[0] ?? '';
                 dataToDownload = this.xRayData.block.raw;
                if (zoneLabel) {
                  
                    fileName = `block_${this.currentFlyer?.title}_P${this.xRayData?.page.raw.index + 1}_B${this.xRayData.block.raw.index}_${zoneLabel}.json`
                } else {
                    fileName = `block_${this.currentFlyer?.title}_P${this.xRayData?.page.raw.index + 1}_basebars.json`
                }
            } else if (this.activeTab === 'page') {
                dataToDownload = this.xRayData.page.raw;
                 let index = this.xRayData?.page.raw.index
                fileName = `page_${this.currentFlyer?.title}_P${this.xRayData?.page.raw.index + 1}_${this.xRayData?.flyer.raw[index].id}.json`
            } else if (this.activeTab === 'flyer') {
                dataToDownload = this.xRayData.flyer.raw;
                fileName = `flyer_${this.currentFlyer?.title}_${this.xRayData?.flyer.raw[0].publicationId}.json`
            } else {
                dataToDownload = this.xRayData;
                fileName = 'jsonData.json'
            }
            const dataStr = JSON.stringify(dataToDownload, null, 2);
            const blob = new Blob([dataStr], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        prettyPrint(obj) {
            const syntaxHighlight = (json) => {
                if (typeof json !== 'string') {
                    json = JSON.stringify(json, null, 3);
                }
                return json.replace(/("(.*?)")(\s*:)?/g, (match, fullMatch, inner, isKey) => {
                    if (isKey) {
                        return `<span class="json-key">${fullMatch}</span>:`
                    } else {
                        return `<span class="json-value">${fullMatch}</span>`
                    }
                });
            };
            return syntaxHighlight(obj);
        },
        prettyPrintJson(obj) {
            const escapeHtml = (str) =>
                str
                    .replace(/&/g, '&amp;').
                    replace(/\\"/g, '&quot;')
                    .replace(/</g, '&lt;').
                    replace(/>/g, '&gt;')

            const syntaxHighlight = (json) => {
                if (typeof json !== 'string') {
                    json = JSON.stringify(json, null, 3);
                }
                json = escapeHtml(json);
                return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
                    let cls = "json-number";
                    if (/^"/.test(match)) {
                        if (/:$/.test(match)) {
                            cls = 'json-key'
                        } else {
                            cls = 'json-string';
                        }
                    } else if (/true|false/.test(match)) {
                        cls = 'json-boolean'
                    } else if (/null/.test(match)) {
                        cls = 'json-null'
                    }
                    return `<span class="${cls}">${match}</span>`
                });
            };
            return syntaxHighlight(obj);
        },
    },
}
</script>
<style lang="scss">
.modal-wpr {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.75);
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;

    .modal-container.resizing {
        outline: 1px dashed #999;
        background-color: rgba(0,0,0, 0.02)
    }

    .modal-container {
        position: relative;
        //  resize: both;
         overflow: hidden;
        width: 800px;
        height: 700px;
        min-width: 360px;
        min-height: 400px;
        max-width: 95vw;
        max-height: calc(97vh - 100px);
        box-sizing: border-box;
        padding: 0.5rem;
        background: transparent;
        border-radius: 12px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);


        .modal {
            // max-height: 82%;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            background-color: #121212;
            border-radius: 10px;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.6);
            display: flex;
            color: #fff;
            font-family: Menlo, Consolas, Monaco, monospace;
            flex-direction: column;
            overflow: hidden;

            .modal-header {
                display: flex;
                flex: 0 0 auto;
                justify-content: center;
                align-items: center;
                padding: 40px 20px 0px 10px;
                border-bottom: 1px solid #333;
                position: relative;

                .tabs {
                    display: flex;
                    gap: 12px;

                    .tab {
                        background: transparent;
                        border: none;
                        color: #bbb;
                        font-weight: 600;
                        padding: 8px 25px;
                        cursor: pointer;
                        border-bottom: 2px solid transparent;
                        transition: all 0.3s ease;

                        &:hover {
                            color: #fff;
                        }

                        &:active {
                            color: #fff;
                            border-bottom: 2px solid #1e88e5;
                        }
                    }
                }

                h2 {
                    margin: 0;
                    font-weight: 600;
                    color: #fff;
                    font-size: 1.2rem;
                }

                .closeBtn {
                    position: absolute;
                    right: 0px;
                    top: -5px;
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    z-index: 99;
                    border-radius: 50px;
                    background-color: transparent;
                    color: #bbb;
                    transition: background-color 0.3s ease, color 0.3s ease;
                    border: none;
                    margin: 10px;

                    &:hover {
                        background-color: #444;
                        color: #eee;
                    }
                }
            }

            .modal-body {
                flex: 1 1 auto;
                overflow: auto;

                .json-controls {
                        margin-top: 10px;
                        margin-left: 12px;
                        display: flex;
                        flex-direction: column;
                       gap: 10px;
                    .toggle-switch {
                        display: inline-flex;
                        align-items: center;
                        cursor: pointer;
                        user-select: none;
                        gap: 8px;
                        font-size: 13px;
                        color: #ccc;
                        
                        input[type="checkbox"] {
                            opacity: 0;
                            width: 0;
                            height: 0;
                            position: absolute;
                        }

                        .slider {
                            position: relative;
                            width: 36px;
                            height: 18px;
                            background-color: #555;
                            border-radius: 12px;
                            transition: background-color 0.3s ease;

                            &::before {
                                content: "";
                                position: absolute;
                                height: 14px;
                                width: 14px;
                                left: 2px;
                                top: 2px;
                                background-color: white;
                                border-radius: 50%;
                                transition: transform 0.3s ease;
                            }
                        }
                        input[type="checkbox"]:checked + .slider{
                            background-color: #1e88e5;
                            &::before {
                                transform: translateX(18px);
                            }
                        }
                        .label-text {
                            color: #80ffff;
                            user-select: none;
                        }
                    }
                }



                .json-output {
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    font-family: Menlo, Consolas, Monaco, monospace;
                    background-color: #121212;
                    padding: 12px;
                    border-radius: 4px;
                    max-height: 700px;
                    font-size: 14px;
                    //color:  #4ec9b0;
                    color: #66ffff;

                    .json-key {
                        // color: red;
                        // display: inline-block;
                        // min-width:10ch;
                        color: #80ffff;
                    }

                    .json-value {
                        color: #ffcc99;
                    }

                    .json-string {
                        white-space: pre-wrap;
                        word-break: break-word;
                        display: inline;
                        color: #ce9178;
                    }

                    .json-number {
                        color: #4ec9b0
                    }

                    .json-boolean {
                        color: #569cd6;
                    }

                    .json-null {
                        color: #c586c0;
                    }

                }
            }

            .modal-footer {
                flex: 0 0 auto;
                // justify-content: flex-end;
                padding: 16px 24px;
                border-top: 1px solid #333;
                display: flex;
                justify-content: center;

                .download-btn {
                    background-color: #1e88e5;
                    color: white;
                    border: none;
                    border-radius: 8px;
                    padding: 0.6rem 1.2rem;
                    box-shadow: 0 3px 8px rgba(20, 136, 229, 0.4);
                    transition: background-color 0.3s ease;
                    font-family: Menlo, Consolas, Monaco, monospace;

                    &:hover {
                        background-color: #1565c0;
                        box-shadow: 0 3px 8px rgba(21, 101, 192, 0.6);
                    }
                }
            }

            .resize-handle {
                position: absolute;
                width: 15px;
                height: 15px;
                bottom: 0;
                right: 0;
                cursor: se-resize;
                background: repeating-linear-gradient(135deg, #fff,#fff 1px, transparent 1px, transparent 4px);
                opacity: 0.5;
            }

            .modal-body {
                scrollbar-width: thin;
                scrollbar-color: #888 #f1f1f1;
            }

            .modal-body::-webkit-scrollbar {
                width: 8px;
                height: 8px;
            }

            .modal-body::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 10px;
            }

            .modal-body::-webkit-scrollbar-thumb {
                background-color: #888;
                border-radius: 10px;
                border: 2px solid #f1f1f1;
            }

            .modal-body::-webkit-scrollbar-thumb:hover {
                background-color: #555;
            }
        }
    }

}
[mode=mobile] {
    .modal-wpr {
        .modal-container {
            height: 550px;
        }
    }
}
</style>